import { ReportPage } from 'src/views/clog/cia-admin/report'
import pathMap from 'src/paths/pathMap'

class CIAAdminReportRoute{
    getConfigurations(){
        return[
            {
                exact: true,
                path: pathMap.CALISTA_ADVISORY_ADMIN_REPORT,
                component: ReportPage
            }
        ]
    }
}

export default CIAAdminReportRoute